<template>
  <div id="registerView">
    <img :src="ds_data.ds_info.fid" style="width: 100%;" />
    <div style="background-color: white;">
      <p
        style="color: #333333;line-height: 30px;font-size: 20px;font-weight: bold;padding: 20px 20px 10px 20px;text-align: left;"
      >
        {{ ds_data.ds_info.name }}{{ ds_data.ds_info.name }}
      </p>
      <p
        style="font-size: 14px;text-align: left;padding: 0px 0px 20px 20px;color: #afafaf;"
      >
        <span style="color: #007AFF;">{{ ds_data.ds_info.create_time }}</span> | {{ ds_data.ds_info.view_num }}人观看
      </p>
    </div>
    <div style="background-color: white;margin-top: 10px;">
      <p
        style="font-size: 16px;font-weight: bold;color: #333333;padding: 10px 20px 10px 20px;text-align: left;"
      >
        {{ ds_data.picArticl.name }}
      </p>
      <div v-dompurify-html="ds_data.picArticl.content">
        {{ ds_data.picArticl.content }}
      </div>
    </div>
    <div style="height: 50px;width: 100%;"></div>
    <div style="left: 0px;bottom: 0px;position: fixed;width: 100%;">
      <van-button
        @click="showKey"
        v-if="ds_data.is_check_play == 'yes'"
        size="large"
        type="primary"
        block
        >登记观看</van-button
      >
      <van-button @click="showKey" v-else size="large" type="primary" block
        >进入直播间</van-button
      >
    </div>
    <tel-test
      @registerok="registerok"
      :fans_id="fans_id"
      :show_type="1"
      :ds_id="ds_id"
      :param-data="keyData"
      v-if="registerIsShow"
    ></tel-test>
  </div>
</template>
<script>
import tool from "../../kits/Tools.js";
import TelTest from "./telTest.vue";
export default {
  components: {
    TelTest,
  },
  data() {
    return {
      ds_data: {
        ds_info: {
          fid: "",
        },
        picArticl: {
          name: "",
          content: "",
        },
      },
      keyData: {},
      registerIsShow: false,
    };
  },
  props: ["loaded", "fans_id","ds_id"],
  watch: {
     ds_id:{
        handler: function(newVal, oldVal) {
           if (newVal) {
              this.getDsInfo()
           }
        },
        immediate: true,
     }
  },
  mounted() {
  },
  methods: {
    getDsInfo() {
      var that = this;
      var option = "ds_id=" + this.ds_id;
      this.axios
        .post(tool.baseUrl1() + "/wap/index/getDsData", option)
        .then(function(data) {
          console.log("data:", data);
          that.ds_data = data.data.data;
        })
        .catch(function(data) {
          Toast("网络错误！");
          console.log("错误" + data);
        });

      var that = this;
      var that = this;
      var option = "ds_id=" + this.ds_id;
      this.axios
        .post(tool.baseUrl1() + "/wap/index/getCheckPlayParams", option)
        .then(function(data) {
          console.log("data:", data);
          that.keyData = data.data.data;
        })
        .catch(function(data) {
          Toast("网络错误！");
          console.log("错误" + data);
        });
    },
    showKey() {
      if (this.ds_data.is_check_play == "yes") {
        this.registerIsShow = true;
      } else {
        this.registerok();
      }
    },
    registerok() {
      this.registerIsShow = false;
      this.$emit("registerOk");
    },
  },
};
</script>

<style scoped>
#registerView {
  top: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  position: fixed;
  z-index: 10002;
  background: #f5f5f5;
  width: 100%;
}

#registerView .title-box {
  background-color: red;
}

.img {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
}

.timeDown {
  position: absolute;
  right: 15px;
  top: 15px;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 6px 12px;
  border-radius: 5px;
  font-size: 12px;
  color: white;
}

p {
  padding: 100px 0;
  text-align: center;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// RegisterView.vue?37107e00